export enum ContractorInfoLabel {
  ContractorBusinessName = 'Contractor Business Name - Please Enter at Least 4 Characters',
  ContractorCity = 'Contractor City',
  ContractorState = 'Contractor State',
  ContractorContactName = 'Contractor Contact Name',
  ContractorContactPhone = 'Contractor Contact Phone',
  ContractorContactEmail = 'Contractor Contact Email',
}

export enum ContractorInfoField {
  ContractorLocated = 'isContractorLocated',
  ContractorBusinessName = 'contractorBusinessName',
  IntermediaryId = 'intermediaryId',
  ContractorCity = 'contractorCity',
  ContractorState = 'contractorState',
  ContractorContactName = 'contractorContactName',
  ContractorPhone = 'contractorPhone',
  ContractorContactEmail = 'contractorContactEmail',
}

export enum ContractorLocatedRadioValue {
  Yes = 'Yes',
  No = 'No',
}
